import { MENU_TYPE } from '../constants';

export function getIndustryCategory(queryParam?: MENU_TYPE) {
  if (queryParam === 'DALIY_VIEW_RANK') {
    return 'VIEWS';
  }

  if (queryParam === 'SALARY_RANK') {
    return 'SALARY';
  }
}
